export const ACCOUNT_ACTIVATION_PHONE_PREFIXES = [
  "1984395",
  "1984301",
  "1950030",
  "1950035",
  "1972905",
  "1972929",
  "1984290",
  "1984393",
  "1844373",
  "1474311",
  "1844375",
  "1874411",
  "1972991",
  "1784301",
];

export const hasAllowedAccountActivationPhonePrefix = (phone) => {
  if (typeof phone !== "string") {
    return false;
  }

  return ACCOUNT_ACTIVATION_PHONE_PREFIXES.some((prefix) =>
    phone.startsWith(prefix)
  );
};

export const validateAccountActivationPhonePrefix = (phone, isValidPhone) => {
  if (!phone || !isValidPhone(phone)) {
    return Promise.resolve();
  }

  if (!hasAllowedAccountActivationPhonePrefix(phone)) {
    return Promise.reject("号码所属地不符");
  }

  return Promise.resolve();
};
